module.exports = "https://static.wanderu.com/static/media/flat-iphone-2x.70f23c16.png";